
import MainRoutes from "./Pages/MainRoutes";
import Navbar from "./Components/Navbar";

function App() {

  return (
    <div >
      <Navbar/>
      <MainRoutes />
      
    </div>
  );
}

export default App;
